export default {
  userAccessFor: 'User access for:',
  save: 'Save',
  search: 'Search',
  name: 'Name',
  lastname: 'Lastname',
  email: 'E-mail'
}
